import { AxiosError } from 'axios';

import { AtiraLinkActions } from '../redux/atira-link/atira-link.slice';
import store from '../redux/store';
import { userActions } from '../redux/user/user.slice';

/** Add actions here that are needed to be dispatched at the start of the app; */
export async function onAppStart() {
  const dispatch = store.store.dispatch;

  try {
    const state = store.store.getState();
    const userId = state.user.loggedInUserId;

    dispatch(userActions.getLoggedInUser({ userId: userId || '' }));
    dispatch(AtiraLinkActions.getUserAtiraLinks({ userId: userId || '' }));
  } catch (e: any) {
    const error = e as AxiosError;
    console.log('Error on app start:', error);

    if (error.response?.status === 401) {
      dispatch(userActions.logout());
    }
  }
}
